import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from 'src/app/helpers/services/api.service';
import { HttpService } from 'src/app/helpers/services/http.service';
import { ToastresService } from 'src/app/helpers/services/toaster.service';

@Component({
  selector: 'app-delete',
  templateUrl: './delete.component.html',
  styleUrls: ['./delete.component.css'],
})
export class DeleteComponent {
  public id: number;
  public data: object;
  public type: string;
  public message: string;

  constructor(
    public activeModal: NgbActiveModal,
    public httpService: HttpService,
    private api: ApiService,
    private toastrsService: ToastresService,
  ) {}

  delete() {
    let apiUrl = '';

    switch (this.type) {
      case 'user':
        apiUrl = this.api.users.delete(this.id);
        break;
      case 'client':
        apiUrl = this.api.clients.delete(this.id);
        break;
      case 'team':
        apiUrl = this.api.teams.delete(this.id);
        break;
      case 'workspace':
        apiUrl = this.api.workspaces.delete(this.id);
        break;
      case 'workspace-project':
        apiUrl = this.api.workspaceProjects.delete(this.id);
        break;
      case 'project':
        apiUrl = this.api.projects.delete(this.id);
        break;
      case 'story':
        apiUrl = this.api.stories.delete(this.id);
        break;
      case 'workspace-list':
        apiUrl = this.api.lists.deleteWorkspaceList(this.id);
        break;
      case 'workspace-project-list':
        apiUrl = this.api.lists.deleteWorkspaceProjectList(this.id);
        break;
      case 'project-list':
        apiUrl = this.api.lists.deleteProjectList(this.id);
        break;
      case 'role':
        apiUrl = this.api.roles.delete(this.id);
        break;
      case 'branch':
        apiUrl = this.api.branches.delete(this.id);
        break;
      case 'currency':
        apiUrl = this.api.currencies.delete(this.id);
        break;
      case 'job_description':
        apiUrl = this.api.jobDescriptions.delete(this.id);
        break;
      case 'contract_type':
        apiUrl = this.api.contractTypes.delete(this.id);
        break;
      case 'department':
        apiUrl = this.api.departments.delete(this.id);
        break;
      case 'company':
        apiUrl = this.api.companies.delete(this.id);
        break;
      case 'feature':
        apiUrl = this.api.features.delete(this.id);
        break;
      case 'workspace-project-task':
        apiUrl = this.api.workspaceProjectTasks.delete(this.id);
        break;
      case 'meeting-task':
        apiUrl = this.api.meetingTasks.delete(this.id);
        break;
      case 'todo':
        apiUrl = this.api.todo.delete(this.id);
        break;
      case 'general-task':
        apiUrl = this.api.generalTasks.delete(this.id);
        break;
      case 'meeting':
        apiUrl = this.api.meetings.delete(this.id);
        break;
      case 'workspace-project-attachment':
        apiUrl = this.api.attachments.delete.workspaceProject(this.id);
        break;
      case 'project-attachment':
        apiUrl = this.api.attachments.delete.project(this.id);
        break;
      case 'story-attachment':
        apiUrl = this.api.attachments.delete.story(this.id);
        break;
      case 'task-attachment':
        apiUrl = this.api.attachments.delete.task(this.id);
        break;
      case 'meeting-attachment':
        apiUrl = this.api.attachments.delete.meeting(this.id);
        break;
      case 'workspace-project-activity':
        apiUrl = this.api.activities.delete.workspaceProject(this.id);
        break;
      case 'project-activity':
        apiUrl = this.api.activities.delete.project(this.id);
        break;
      case 'story-activity':
        apiUrl = this.api.activities.delete.story(this.id);
        break;
      case 'task-activity':
        apiUrl = this.api.activities.delete.task(this.id);
        break;
      case 'meeting-activity':
        apiUrl = this.api.activities.delete.meeting(this.id);
        break;
      case 'agenda-item':
        apiUrl = this.api.agendaItems.delete(this.id);
        break;
      case 'monthly-project':
        apiUrl = this.api.monthlyProjects.delete(this.id);
        break;
      case 'bank':
        apiUrl = this.api.banks.delete(this.id);
        break;
      case 'contract':
        apiUrl = this.api.contracts.delete(this.id);
        break;
      case 'invoice':
        apiUrl = this.api.invoices.delete(this.id);
    }

    this.httpService.action(apiUrl, this.data, 'actionDeleteLoader').subscribe({
      next: (res: any) => {
        if (res.success) {
          this.activeModal.close(res);
          this.toastrsService.ShowSuccess(res.msg);
        } else {
          this.toastrsService.ShowError(res.msg);
        }
      },
    });
  }
}
